// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 535 ? "login" : chunkId) + "-legacy." + {"78":"cc4baeef","338":"63d6b214","535":"0f57b97d","576":"50f1a4f0","753":"3aa376dc","775":"2f4a1ceb","823":"0a3858a0","990":"df4233a7"}[chunkId] + ".js";
};